import { Recipes } from "../modules/recipes";

export const RecipesPage = () => {
  return <Recipes />;
};
